import styled from 'styled-components'
import { COLORS } from '../../../../styles/colors'
import { CALENDAR_DIMENSIONS } from '../../constants/constants'

export const StyledCalendar = styled.div`
	width: ${CALENDAR_DIMENSIONS.CONTAINER_WIDTH}px;
	height: ${CALENDAR_DIMENSIONS.CONTAINER_HEIGHT}px;
	background: ${COLORS.white};
	border-radius: 12px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
	display: flex;
	flex-direction: column;
`

export const CalendarContent = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	padding: ${CALENDAR_DIMENSIONS.CONTAINER_PADDING}px;
	overflow: hidden;
`

export const WeekdaysRow = styled.div`
	display: grid;
	grid-template-columns: repeat(7, 1fr);
	column-gap: ${CALENDAR_DIMENSIONS.CELL_GAP_HORIZONTAL}px;
	margin-bottom: 16px;
`

export const WeekdayLabel = styled.div`
	width: ${CALENDAR_DIMENSIONS.DAY_CELL_SIZE}px;
	height: ${CALENDAR_DIMENSIONS.HEADER_TEXT_HEIGHT}px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${COLORS.secondary};
	font-size: 14px;
	font-weight: 400;
`

export const DaysGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(7, 1fr);
	grid-template-rows: repeat(5, 1fr);
	column-gap: ${CALENDAR_DIMENSIONS.CELL_GAP_HORIZONTAL}px;
	row-gap: ${CALENDAR_DIMENSIONS.CELL_GAP_VERTICAL}px;
	overflow: visible;
`
